import { ProgressCircleProps } from '$shared/components/ProgressCircle/ProgressCircle.interface';
import './ProgressCircle.sass';

export const ProgressCircle = ({
  radius,
  strokeWidth,
  progress,
  isSpinning,
  isDisableLoader,
}: ProgressCircleProps) => {
  const normalizedRadius = radius - strokeWidth * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const currentProgress = progress < 10 ? 10 : progress;
  const strokeDashoffset = circumference - (currentProgress / 100) * circumference;

  return (
    <svg height={radius * 2} width={radius * 2} className="ProgressCircle">
      {!isDisableLoader && (
        <circle
          className={isSpinning && progress !== 100 ? '_isSpinning' : ''}
          stroke="black"
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference + ' ' + circumference}
          style={{ strokeDashoffset }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      )}
    </svg>
  );
};
